import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import flashMessageMixin from '../../mixins/_flash_messages';
import modalBatchSettingsItem from './modal_batch_settings_parts/_item';
import modalBatchSettingsTax from './modal_batch_settings_parts/_tax';
import modalBatchSettingsWeight from './modal_batch_settings_parts/_weight';

// 全体設定種別リスト
const BATCH_SETTINGS_KIND = {
    item: {
        title: '<i class="fas fa-tag mr-2"></i>送料無料アイコン',
        component: 'modal-batch-settings-item'
    },
    tax: {
        title: '<i class="fas fa-yen-sign mr-2"></i>消費税の設定', // 仮テキスト表示
        component: 'modal-batch-settings-tax'
    },
    weight: {
        title: '<i class="fas fa-tag mr-2"></i>重量',
        component: 'modal-batch-settings-weight'
    },
};

/**
 * 送料無料設定モーダル
 */
export default {
    name: 'modalBatchSettings',
    template: '#modal_batch_settings_template',
    data() {
        return {
            allKinds: BATCH_SETTINGS_KIND,
            currentKind: '',
            batchSettingData: {},
        };
    },
    mixins: [commonMixin, modalMixin, flashMessageMixin],
    components: {
        // 送料無料設定
        'modal-batch-settings-item': modalBatchSettingsItem,
        // 税率設定
        'modal-batch-settings-tax': modalBatchSettingsTax,
        // 重量設定
        'modal-batch-settings-weight': modalBatchSettingsWeight,
    },
    computed: {
        // 下書きアイテムリスト数を返却する
        numOfDraftList: function () {
            return this.draft_list.length;
        },
        // 下書きアイテムが有るか
        hasDraftList: function() {
            return (this.numOfDraftList > 0);
        },
    },
    methods: {
        initialize: async function() {
            try {
                this.clearFlashMessage(null, this.$parent);
                await this.getBatchSetting();
            } catch (e) {
                // エラーメッセージを表示
                this.appendFlashMessage(
                    {
                        level: 'alert-danger',
                        message: this.getCatchMessage(e)
                    },
                    this.$parent
                );
            }
        },
        // モーダルを開く
        openModal: async function() {
            this.currentKind = Object.keys(this.allKinds)[0];
            await this.$nextTick();
            await this.initialize();
            this.open();
        },
        // kindから全体設定を取得する
        getBatchSetting: async function() {
            try {
                this.$_loading();
                const response = await axios.get('/item/get_batch_setting', {
                    params:{
                        _method: 'GET',
                        kind: this.currentKind,
                    }});
                this.batchSettingData = {};
                if (response.data.status === 'OK') {
                    const batchSetting = response.data.batch_setting;
                    if (batchSetting !== null) {
                        this.batchSettingData = {
                            is_enable: batchSetting.is_enable,
                            ...(batchSetting.data ?? {})
                        };
                    }
                }
            } finally {
                this.$_unloading();
            }
        },
        // kindから全体設定設定を保存する
        saveBatchSetting: async function() {
            try {
                this.clearFlashMessage(null, this.$parent);
                this.$_loading();
                const response = await axios.put('/item/save_batch_setting', {
                    _method: 'PUT',
                    kind: this.currentKind,
                    ...(this.$refs[`settings_${this.currentKind}`][0].getData()),
                });
                if (response.data.status === 'OK') {
                    // モーダルを閉じる
                    this.close();
                }

            } catch (e) {
                // エラーメッセージを表示
                this.appendFlashMessage(
                    {
                        level: 'alert-danger',
                        message: this.getCatchMessage(e),
                    },
                    this.$parent
                );
            } finally {
                this.$_unloading();
            }
        },
        // kind変更時
        onChangeKind: async function(event) {
            this.currentKind = event.target.dataset.kind;
            await this.initialize();
        },
    }
};
